import { pick } from 'lodash'
import { track } from '../analytics'

export const personasPreviewEnabled = args => {
  track(
    'Personas Preview Enabled',
    pick(args, ['workspaceId', 'workspaceSlug', 'userEmail'])
  )
}
